import axios from 'axios';
import properties from '../../properties';

export interface CohortMembersCountResponse {
  noOfMemberIds: number;
  member_unique_ids: string[];
}

export const getCohortMembersCount = async (
  eg_nid: string[],
  endDate: string,
  max_claim_date: string,
): Promise<CohortMembersCountResponse> => {
  const response = await axios.post(
    properties.aiqBaseUrl +
      properties.summaryBaseUrl +
      properties.getCohortMembersCount,
    {
      eg_nid,
      endDate,
      max_claim_date,
    },
  );
  return response.data.data;
};

export const getClaimCohortMembersCount = async (
  eg_nid: string[],
  incurredStartDate: string,
  incurredEndDate: string,
  paidStartDate: string,
  paidEndDate: string,
  aggregationParameter: string,
): Promise<CohortMembersCountResponse> => {
  const response = await axios.post(
    properties.aiqBaseUrl +
      properties.summaryBaseUrl +
      properties.getClaimCohortMembersCount,
    {
      eg_nid,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
    },
  );
  return response.data.data;
};
